export default [
    {
      path: '/services',
      name: 'services-read',
      component: () => import('@/views/service/service-list/ServiceList.vue'),
      meta: {
        resource: 'Services',
        action: 'read',
      },
    },
    {
        path: '/services/create',
        name: 'services-create',
        component: () => import('@/views/service/service-list/ServiceForm.vue'),
        meta: {
          resource: 'Services',
          action: 'create',
        },
    },
    {
      path: '/services-category',
      name: 'services-category-read',
      component: () => import('@/views/service/category-list/CategoryList.vue'),
      meta: {
        resource: 'Services Categories',
        action: 'read',
      },
    },
    {
      path: '/services-category/create',
      name: 'services-category-create',
      component: () => import('@/views/service/category-list/CategoryForm.vue'),
      meta: {
        resource: 'Services Categories',
        action: 'create',
      },
    },
  ]
  